import React from "react";

const Loading = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center h-100"
      style={{ padding: "48px 16px" }}
    >
      <div className="dot-loader">
        <span />
        <span />
        <span />
        <span />
      </div>

      <style>
        {`
        .dot-loader {
          display: flex;
          gap: 8px;
        }

        .dot-loader span {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #263146;
          animation: dotBounce 0.8s infinite ease-in-out;
        }

        .dot-loader span:nth-child(2) {
          animation-delay: 0.1s;
          background: #418BFF;
        }

        .dot-loader span:nth-child(3) {
          animation-delay: 0.2s;
          background: #263146;
        }

        .dot-loader span:nth-child(4) {
          animation-delay: 0.3s;
          background: #418BFF;
        }

        @keyframes dotBounce {
          0%, 80%, 100% {
            transform: scale(0.6);
            opacity: 0.5;
          }
          40% {
            transform: scale(1);
            opacity: 1;
          }
        }
        `}
      </style>
    </div>
  );
};

export default Loading;